module.exports = __webpack_public_path__ + "img/bgclean.91a3811d.jpg";